/**
 * Cleans up localStorage on the start of a new browser tab session,
 * retaining only the SESSION_ID and auth keys.
 *
 * This function prevents the accidental loss of authentication or session
 * data when the application is opened in a new tab (e.g., via right-click or Ctrl+click).
 *
 * Usage: Call this function once at the very beginning of your application's entry point.
 *
 * How it works:
 * - Uses sessionStorage (tab-scoped) to determine if this is the first load in the current tab.
 * - If a new tab session is detected, it:
 *   - Clears localStorage entirely.
 *   - Restores only the SESSION_ID and auth keys.
 *   - Updates SESSION_ID with a new value unique to this tab session.
 * - If an existing tab session is detected, it:
 *   - Updates SESSION_ID in localStorage to match the current tab session.
 *   - Does not clear any data.
 *
 * @function
 */
function cookiesCleanUp() {
  const SESSION_ID_KEY = 'SESSION_ID';
  const AUTH_KEY = 'auth';
  const SESSION_STARTED_KEY = 'SESSION_STARTED';

  const sessionId = sessionStorage.getItem(SESSION_STARTED_KEY);

  if (!sessionId) {
    // New tab session started
    const newSessionId = Date.now().toString();
    sessionStorage.setItem(SESSION_STARTED_KEY, newSessionId);

    // Backup values to retain
    const authValue = localStorage.getItem(AUTH_KEY);

    // Clear localStorage completely
    localStorage.clear();

    // Restore SESSION_ID and auth keys
    localStorage.setItem(SESSION_ID_KEY, newSessionId);
    if (authValue !== null) {
      localStorage.setItem(AUTH_KEY, authValue);
    }

    console.log('New tab session: localStorage cleaned except SESSION_ID and auth.');
  } else {
    // Existing tab session — do not clear localStorage
    localStorage.setItem(SESSION_ID_KEY, sessionId);
    console.log('Existing tab session: localStorage preserved.');
  }
}

export default cookiesCleanUp;